import React, { ReactChildren, ReactNode } from 'react';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  ArrowBackOutlined as BackIcon,
  CloseOutlined as CloseIcon,
} from '@material-ui/icons';
import {
  WithStyles,
  createStyles,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Button,
} from '@material-ui/core';

import MyPATIconButton from './MyPATIconButton';
import PerfectScrollbar from 'react-perfect-scrollbar';

const styles = (theme: Theme) => createStyles({
  iconRoot: {
    fill: theme.palette.text.secondary,
    // opacity: 0.5,
    margin: 0,
    width: '2rem',
    height: '2rem',
  },
  textRight: {
    textAlign: 'right',
  },
  headerIcon: {
    position: 'absolute',
    right: 10,
  },
  overflowVisible: {
    overflow: 'visible'
  },
  dialogPaperRoot: {
    background: '#FFFF',
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.287534)',
    borderRadius: 4,
  },
  dialogWhitePaperRoot: {
    backgroundColor: theme.palette.common.white, 
  },
  borderNone: {
    border: '1px solid rgba(0, 0, 0, 0)'
  },
  borderDialogAction: {
    border: '1px solid rgb(226, 226, 226)',
  },
  cancelBtn: {
    color: 'rgb(29, 125, 234)',
    border: '1px solid rgb(29, 125, 234)',
    borderRadius: 2,
    padding: '0px 32px'
  },
  buttonFont: {
    letterSpacing: '0.5px',
    fontSize: 16
  },
  greyBackground: {
     backgroundColor: '#F7F7F7'
  },
  whiteBackground: {
    backgroundColor: '#fff'
  },
  saveBtn: {
    background: '#1D7DEA',
    border: '1px solid #1D7DEA',
    borderRadius: 2,
    color: '#fff',    
    padding: '0px 32px'
  },
  borderBottomTitle: {
    borderBottom: '1px solid #e2e2e2',
    borderRadius: '4px 4px 0px 0px'
  },
  dialogTitle: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    backgroundColor: 'white',
    '& > h6 > div': {
      minHeight: 49,
    },
    textTransform: 'capitalize'
  },
  perfectScrollbar: {
    ...theme.mixins.gutters(),
    paddingTop: 20,
    maxHeight: 'inherit',
    borderRadius: 4,
    '& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y': {
      opacity: 1
    },
    paddingBottom: 24
  },
  stopParentScroll: {
    '& .ps': {
      overflow: 'initial !important',
    },
    '& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y': {
      display: 'none',
    },
  },
  dialogWidthSm: {
    position: 'absolute',
    width: 800,
    display: 'flex'
  },
  dialogActions: { 
    borderRadius: '0px 0px 4px 4px',
    ...theme.mixins.gutters(),
    paddingTop: 12,
    paddingBottom: 12,
    '& button': {
      margin: `0 ${theme.spacing.unit / 2}px`,
    },
    margin: 0
  },
  fontLG: {
    fontWeight: 600,
    fontSize: '1.2rem',
    lineHeight: '2.5'
  },
  headingLeftClose: {
    fontSize: '1.5rem',
  },
  headingTitleLeft: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit + 4,
    paddingBottom: theme.spacing.unit + 4,
    backgroundColor: 'white',
    '& h5':{
      fontWeight: 600,
      color: '#333333'
    },
  },
  alignCenter: {
    textAlign: 'center'
  },
  headingCenterTitle: {
    fontFamily: 'Nunito',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 28,
    lineHeight: '32px',
    color: '#333333'
  },
  alignLeft: {
    textAlign: 'left'
  },
  dialogContent: {
    padding: 0,
    maxHeight: 500,    
    minWidth: 500,
  },

  customDialogContent:{
    width: "100%",
    minWidth: 500,
    maxWidth: 750,
    maxHeight: 500,
    paddingBottom: 50,
    height: "calc(600px - 50px)",
    overflow: "auto",
    "@media (max-width: 1280px)": {
        paddingBottom: 60,
        height: 'calc(600px - 150px)',
    },
    "@media (max-width: 1024px)": {
      paddingBottom: 110,
      height: 'calc(600px - 200px)',
    }
  },

  fixedDialogActions:{
    position: 'absolute',
    width: '100%',
    bottom: 0,
    zIndex: 100,
    paddingTop: 0,
  },
  paddingLG: {
    padding: "24px 36px",
  },
  overflowInital: {
    overflowY: 'initial'
  },
  root: {
    overflow: 'hidden'
  },


});

interface MyPATDialogProps extends WithStyles<typeof styles> {
  classes: any,
  customDialogTitle: ReactNode,
  children: ReactChildren,
  customDialogActions: ReactNode,

  onDialogClose: () => void,
  onDialogBack: () => void,
  onDialogCancel: () => void,
  onDialogSave: () => void,
  onDialogDelete: () => void,

  dialogHeading: string,
  dialogOpen: boolean,
  variant: string,
  variantHeader: string,
  isAlignCenter: boolean,

  labelSaveButton: string,
  dialogWidth: string,
  otherDialogProps: object,
  isborderDialogAction: boolean,
  isCustomBackground: boolean,
  customButtonVariant: string,

  isPerfectScrollbar: boolean,
  customHtmlWrapper: ReactNode,
  isCustomWrapper: boolean,
  isOverflowVisible: boolean,
  isFooterWhite?:boolean,
  isApplyCustom?:boolean,
  isfixedDialogActions?:boolean,
  isCloseButtonHidden?: boolean,
  stopParentScroll?: boolean,
  dialogCustomClasses?: any
}

const MyPATDialog = (props: MyPATDialogProps) => {
  const {
    classes,
    customDialogTitle,
    children,
    customDialogActions,

    onDialogClose,
    onDialogBack,
    onDialogCancel,
    onDialogSave,
    onDialogDelete,

    dialogHeading,
    dialogOpen,
    isAlignCenter,
    variant = 'default',
    variantHeader = 'default',
    labelSaveButton = 'Save',
    dialogWidth = 'auto',
    otherDialogProps,
    isborderDialogAction = false,
    isCustomBackground = false,
    customButtonVariant = ' ',
    isPerfectScrollbar = true,
    isCustomWrapper = false,
    customHtmlWrapper,
    isOverflowVisible = false,
    isFooterWhite=false,
    isApplyCustom = false,
    isfixedDialogActions = false,
    isCloseButtonHidden = false,
    stopParentScroll = false,
    dialogCustomClasses
  } = props;

  const DefaultDialogHeading = () => (
    <Grid container justify="center" direction="row" alignItems="center">
      {/* {!_.isUndefined(onDialogBack) && (
        <Grid item xs="auto">
          <MyPATIconButton buttonVariant="flat" onClick={onDialogBack}>
            <BackIcon classes={{ root: classes.iconRoot }} />
          </MyPATIconButton>
        </Grid>
      )} For future pupose only*/}
      <Grid item>
        <Typography variant="h6" className={isAlignCenter ? 
        [classes.alignCenter, classes.headingCenterTitle].join(' ') : 
        [classes.fontLG,classes.alignLeft].join(' ')}>{dialogHeading}</Typography>
      </Grid>

      <Grid item className={classes.headerIcon}>
        {isCloseButtonHidden ? (
          <></>
        ) : (
          <MyPATIconButton
            buttonVariant={customButtonVariant || "flat"}
            onClick={onDialogClose}
          >
            <CloseIcon classes={{ root: classes.iconRoot }} />
          </MyPATIconButton>
        )}
      </Grid>
    </Grid>
  );


  const DefaultDialogHeadingLeft = () => (
    <Grid container justify="space-between" alignItems="center">
      <Grid item xs>
        <Typography variant="h6" align="left" className={classes.fontLG}>{dialogHeading}</Typography>
      </Grid>

      <Grid item xs="auto" className={classes.textRight}>
        <MyPATIconButton buttonVariant={customButtonVariant || 'flat'} onClick={onDialogClose}>
          <CloseIcon classes={{ root: classes.iconRoot }} className={classes.headingLeftClose} />
        </MyPATIconButton>
      </Grid>
    </Grid>
  );

  const DefaultDialogActions = () => (
    <Grid container alignItems="center" justify="space-between">
      <Grid item xs>
        {!_.isUndefined(onDialogDelete) && <Button onClick={onDialogDelete}>Delete</Button>}
      </Grid>
      <Grid item xs className={classes.textRight}>
        {!_.isUndefined(onDialogCancel) && <Button onClick={onDialogCancel} className={[classes.cancelBtn, classes.buttonFont].join(' ')}>Cancel</Button>}
        {!_.isUndefined(onDialogSave) && <Button variant="contained" className={[classes.saveBtn, classes.buttonFont].join(' ')} onClick={onDialogSave}>{labelSaveButton}</Button>}
      </Grid>
    </Grid>
  );

  const hasDialogTitle = !_.isEmpty(customDialogTitle) || !_.isEmpty(dialogHeading);

  const isDefaultDialogAction = !_.isUndefined(onDialogCancel) || !_.isUndefined(onDialogSave) || !_.isUndefined(onDialogDelete);
  const hasDialogAction = !_.isEmpty(customDialogActions) || isDefaultDialogAction;

  const dialogVariantClasses = () => {
    switch (variant) {
      case 'white': {
        return { paper: [classes.dialogWhitePaperRoot, isOverflowVisible ? classes.overflowVisible : ''].join(' ') };
      }
      default: {
        return { paper: [classes.dialogPaperRoot, isOverflowVisible ? classes.overflowVisible : ''].join(' ') };
      }
    }
  }

  const dialogVariantHeader = () => {
    switch (variantHeader) {
      case 'leftHeader': {
        return { component: (<DefaultDialogHeadingLeft />), dialogTitle: classes.headingTitleLeft };
      }
      default: {
        return { component: (<DefaultDialogHeading />), dialogTitle: classes.dialogTitle };
      }
    }
  }

  return (
    <Dialog
      classes={{ paper: [dialogVariantClasses().paper, isOverflowVisible ? classes.overflowVisible : ''].join(' '), 
        paperScrollPaper: classes.root
      }}
      disableBackdropClick
      disableEscapeKeyDown
      open={dialogOpen}
      onClose={onDialogClose}
      role="paper"
      // PaperProps={{style: {overflow: 'visible'}}}
      {...otherDialogProps}
    >
      <div style={{ width: `${dialogWidth}` }}>
        {
          hasDialogTitle && (
            (dialogHeading === ' ') ?
              <>

                <DialogTitle
                  className={[classes.borderNone, dialogVariantHeader().dialogTitle].join(' ')}>
                  {
                    (_.isEmpty(dialogHeading) && !_.isEmpty(customDialogTitle))
                      ? customDialogTitle
                      : dialogVariantHeader().component
                  }
                </DialogTitle>
              </>
              :
              <>
                <DialogTitle
                  className={[classes.borderBottomTitle, dialogVariantHeader().dialogTitle].join(' ')}>

                  {
                    (_.isEmpty(dialogHeading) && !_.isEmpty(customDialogTitle))
                      ? customDialogTitle
                      : dialogVariantHeader().component
                  }
                </DialogTitle>
              </>
          )}

        <DialogContent classes={{root: [classes.dialogContent, 
        isApplyCustom ? [classes.customDialogContent]: '',
        isOverflowVisible ? [classes.overflowVisible, !isCustomWrapper && classes.paddingLG].join(' ') : '',
        !isPerfectScrollbar ? classes.overflowInital : 'dialogContent', stopParentScroll ? classes.stopParentScroll : '',
        dialogCustomClasses
        ].join(' ') }}>
          <>
          {
          !isPerfectScrollbar ?
          <>
          {children}
          </>          
          :
            isOverflowVisible 
            ?
            <>{children}</>
            :
            <PerfectScrollbar className={[`dialog-content ${classes.perfectScrollbar}`,
            isCustomBackground ? classes.greyBackground : classes.whiteBackground, 'perfectScrollBar'].join(' ')}>
              {children}
            </PerfectScrollbar>
          }
          </>
        </DialogContent>
        {
          hasDialogAction && (
            <DialogActions
              className={[
                isOverflowVisible ? classes.overflowVisible : '',
                isfixedDialogActions ? classes.fixedDialogActions : '',
                (customDialogActions && isborderDialogAction)
                ? classes.borderNone
                : classes.borderDialogAction, 
                classes.dialogActions, 
                isCustomBackground ? classes.greyBackground : classes.whiteBackground , isFooterWhite? classes.whiteBackground:classes.greyBackground].join(' ')}>
                  
              {(!isDefaultDialogAction && !_.isEmpty(customDialogActions))
                ? customDialogActions
                : <DefaultDialogActions />
              }
            </DialogActions>
          )
        }
      </div>

    { isCustomWrapper && 
      customHtmlWrapper
    }
    </Dialog>
  );
};


//@ts-ignore
export default withStyles(styles)(MyPATDialog);